//@flow
import { withProps } from 'recompose'

/**
 * This provides an <code>onSubmitFail</code> function that works with
 * Redux-Form. It will receive sync validation errors and will map a camel cased
 * redux form Field `name` to an HTML dashed-case input `id`, setting focus on it
 * @param {Array<String>} orderedFieldList List of fields in order of appeareance
 * @returns {Object} Object with `onSubmitFail` prop
 */
export const withAutoFocusOnError = (orderedFieldList: string[]) =>
  withProps(props => {
    // this works because form field "names" are camel case and input "ids" are
    // dashed-cased, so we can map from redux Form validation error to input ids
    // and manually set focus
    const focusFieldName = fieldName => {
      const dashedCaseName = fieldName.replace(/[A-Z]/g, function($1) {
        return '-' + $1.toLowerCase()
      })
      try {
        const node = document.getElementById(dashedCaseName)
        node && node.focus()
      } catch (err) {
        console.warn('Tried to focus field ' + dashedCaseName + ' failed', err)
      }
    }
    return {
      onSubmitFail(errors) {
        if (!document.getElementById) return
        const firstFieldWithError = orderedFieldList.find(
          fieldName => !!errors[fieldName]
        )
        firstFieldWithError && focusFieldName(firstFieldWithError)
      }
    }
  })

export default withAutoFocusOnError



// WEBPACK FOOTER //
// ./src/services/register-charity/withAutofocusOnError.js